import { render } from "./BoxPaymentPopup.vue?vue&type=template&id=0f4a0d3a&scoped=true"
import script from "./BoxPaymentPopup.vue?vue&type=script&lang=js"
export * from "./BoxPaymentPopup.vue?vue&type=script&lang=js"

import "./BoxPaymentPopup.vue?vue&type=style&index=0&id=0f4a0d3a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4a0d3a"]])

export default __exports__